import { useParams, Link, Navigate } from "react-router-dom";
import SEOHead from "@/components/app/SEOHead";
import { LEGAL_PAGES, LEGAL_INDEX } from "@/data/legalPages";

export default function Legal() {
  const { slug } = useParams();
  const page = LEGAL_PAGES[slug];

  if (!page) {
    return <Navigate to="/legal/about" replace />;
  }

  return (
    <div className="max-w-3xl mx-auto px-4 sm:px-8 py-16" data-testid={`legal-page-${slug}`}>
      <SEOHead
        title={`${page.title} — WhichUniversityAdvisor.com`}
        description={page.lede || page.title}
        path={`/legal/${slug}`}
        image="/og/uk-visa-friendly-degrees.png"
        type="article"
      />
      <nav className="text-xs font-underground-sc tracking-wider text-stone-500 mb-4">
        <Link to="/" className="hover:text-stone-900" data-testid="legal-breadcrumb-home">Home</Link>
        <span className="mx-2 text-stone-300">/</span>
        <span className="text-stone-700">{page.title}</span>
      </nav>

      <h1
        data-testid={`legal-heading-${slug}`}
        className="font-editorial text-4xl sm:text-5xl leading-tight"
      >
        {page.title}
      </h1>
      {page.updated && (
        <p className="mt-2 text-xs font-underground-sc tracking-wider text-stone-500">
          Last updated · {page.updated}
        </p>
      )}
      {page.lede && (
        <p className="mt-4 text-lg text-stone-700 leading-relaxed">{page.lede}</p>
      )}

      <div className="mt-10 space-y-10">
        {page.sections.map((sec, i) => (
          <section key={i} data-testid={`legal-section-${slug}-${i}`}>
            <h2 className="font-editorial text-2xl text-stone-900">{sec.heading}</h2>
            <div className="mt-3 space-y-3 text-stone-700 leading-relaxed text-[15px]">
              {sec.body.map((para, j) => (
                <p key={j}>{para}</p>
              ))}
              {sec.list && (
                <ul className="list-disc pl-6 space-y-1.5">
                  {sec.list.map((item, k) => (
                    <li key={k}>{item}</li>
                  ))}
                </ul>
              )}
            </div>
          </section>
        ))}
      </div>

      <div className="mt-16 pt-8 border-t border-stone-200">
        <div className="label-uppercase mb-3">Related</div>
        <ul className="text-sm space-y-1.5">
          {LEGAL_INDEX.filter((p) => p.slug !== slug).map((p) => (
            <li key={p.slug}>
              <Link
                to={`/legal/${p.slug}`}
                data-testid={`legal-related-${p.slug}`}
                className="text-[#4C1D95] hover:underline underline-offset-4"
              >
                {p.title}
              </Link>
            </li>
          ))}
        </ul>
      </div>
    </div>
  );
}
